import Constants from '../constants'

export default {
   ORGANIZATION_URL: Constants.BASE_URL + '/organization'
}

export const Actions = {
   new:    'org:new',
   update: 'org:update',
   list:   'org:list',
   change: 'org:change'
}



// WEBPACK FOOTER //
// lib/api/organization/Constants.js